import React, { useEffect, useState } from "react";

const BannerRotativo = () => {
  const imagenes = [
    "https://surtilight.com/cdn/shop/articles/11---Lamparas-para-exterior-la-mejor-iluminacion-para-espacios-abiertos.jpg?v=1686108604&width=2048",
    "https://i.blogs.es/f022cc/lights-1867437/1366_2000.jpg",
    // Puedes agregar más imágenes...
  ];

  const [imagenActual, setImagenActual] = useState(
    imagenes[Math.floor(Math.random() * imagenes.length)]
  );

  useEffect(() => {
    const intervalo = setInterval(() => {
      setImagenActual((anterior) => {
        let siguiente;
        do {
          siguiente = imagenes[Math.floor(Math.random() * imagenes.length)];
        } while (siguiente === anterior);
        return siguiente;
      });
    }, 15000);

    return () => clearInterval(intervalo);
  }, [imagenes]);

  return (
    <div
      style={{
        width: "100%",
        height: "400px",
        backgroundImage: `url(${imagenActual})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: "0 0 0 20px",
        color: "white",
        textAlign: "right",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          padding: "20px 30px",
          borderTopLeftRadius: "30px",
          borderBottomLeftRadius: "30px",
          maxWidth: "90%",
          textShadow: "0px 0px 10px rgba(0,0,0,0.8)",
        }}
      >
        <h1
          style={{
            fontSize: "clamp(1.5rem, 5vw, 3rem)",
            fontWeight: "bold",
            margin: 0,
          }}
        >
          ILUMINA TU VIDA
        </h1>
        <p
          style={{
            fontSize: "clamp(1rem, 2.5vw, 1.5rem)",
            marginTop: "10px",
          }}
        >
          Tu espacio, tu esencia… ¡ilumínalo a tu manera! 💡✨
        </p>
        <button
          style={{
            marginTop: "15px",
            backgroundColor: "#8ac20b", // verde naturaleza
            color: "white",
            border: "none",
            padding: "10px 20px",
            borderRadius: "20px",
            fontWeight: "bold",
            fontSize: "1rem",
            cursor: "pointer",
          }}
        >
          Ver más
        </button>
      </div>
    </div>
  );
};

export default BannerRotativo;
